
<template>
  <el-dialog :title="title" :visible.sync="visible" v-loading="loading" :close-on-click-modal="false" width="50%">
    <el-form ref="addForm" :model="addForm" :rules="addFormRule" inline label-width="160px">
      <!-- <el-form-item label="收款人编号">
              <el-input v-model="addForm.payeeNo" disabled />
            </el-form-item> -->

      <el-form-item label="商户编号">
        <el-input v-model="addForm.merNo" disabled />
      </el-form-item>

      <el-form-item label="商户名称">
        <el-input v-model="addForm.merName" disabled />
      </el-form-item>

      <!-- <el-form-item v-if="type === 'lookup'" label="收款方名称" prop="accountName">
        <el-input v-model="addForm.accountNameMask" disabled />
      </el-form-item> -->

      <el-form-item label="收款方名称" prop="accountName">
        <el-input v-model="addForm.accountName" :disabled="type==='lookup'" />
      </el-form-item>

      <!-- <el-form-item v-if="type === 'lookup'" label="收款账号" prop="accountNo">
        <el-input v-model="addForm.accountNoMask" @blur="check_banknum($event, 'accountNo')" disabled />
      </el-form-item> -->
      <el-form-item label="收款账号" prop="accountNo">
        <el-input v-model="addForm.accountNo" @blur="check_banknum($event, 'accountNo')" :disabled="type==='lookup'" />
      </el-form-item>

      <el-form-item label="收款人地址" prop="receiverAddr">
        <el-input v-model="addForm.receiverAddr" :disabled="type === 'lookup'" />
      </el-form-item>

      <el-form-item label="开户行名称" prop="bankName">
        <el-input v-model="addForm.bankName" :disabled="type === 'lookup'" />
      </el-form-item>

      <el-form-item label="开户行地址" prop="bankAddr">
        <el-input v-model="addForm.bankAddr" :disabled="type === 'lookup'" />
      </el-form-item>

      <el-form-item label="开户行swift BIC" prop="bankSwiftBic">
        <el-input v-model="addForm.bankSwiftBic" :disabled="type === 'lookup'" />
      </el-form-item>

      <el-form-item label="收款人常驻国家名称:" prop="countryName">
        <el-select
          v-model="addForm.countryName"
          value-key="paramKey"
          filterable
          placeholder="全部"
          :disabled="type === 'lookup'"
          @change="getCountryValue($event)"
        >
          <el-option v-for="item in countryOptions" :key="item.paramKey" :label="item.paramValue" :value="item" />
        </el-select>
      </el-form-item>
      <el-form-item label="收款人常驻国家代码">
        <el-input v-model="addForm.countryCode" disabled />
      </el-form-item>

      <el-form-item v-if="type === 'add'" label="常用结算币种:" prop="settlementCurrencyList">
        <el-select
          v-model="addForm.settlementCurrencyList"
          value-key="paramKey"
          filterable
          multiple
          placeholder="全部"
          :disabled="type === 'lookup'"
        >
          <el-option v-for="item in currencyOptions" :key="item.paramKey" :label="item.paramValue" :value="item" />
        </el-select>
      </el-form-item>

      <el-form-item v-if="type === 'add'" label="结算币种代码">
        <el-select
          v-model="addForm.settlementCurrencyList"
          value-key="paramKey"
          filterable
          multiple
          placeholder="全部"
          disabled
        >
          <el-option v-for="item in currencyOptions" :key="item.paramKey" :label="item.paramKey" :value="item" />
        </el-select>
      </el-form-item>

      <el-form-item v-if="type === 'update'" label="常用结算币种:" prop="settlementCurrencyName">
        <el-select
          v-model="addForm.settlementCurrencyName"
          value-key="paramKey"
          filterable
          placeholder="全部"
          @change="getCurrencyValue($event)"
        >
          <el-option v-for="item in currencyOptions" :key="item.paramKey" :label="item.paramValue" :value="item" />
        </el-select>
      </el-form-item>

      <el-form-item v-if="type === 'update'" label="结算币种代码" prop="settlementCurrencyCode">
        <el-input v-model="addForm.settlementCurrencyCode" disabled />
      </el-form-item>

      <el-form-item v-if="type === 'lookup'" label="常用结算币种:" prop="settlementCurrencyName">
        <el-input v-model="addForm.settlementCurrencyName" disabled />
      </el-form-item>

      <el-form-item v-if="type === 'lookup'" label="结算币种代码" prop="settlementCurrencyCode">
        <el-input v-model="addForm.settlementCurrencyCode" disabled />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button v-if="type === 'add' || type === 'update'" type="primary" @click.native="submit">提交</el-button>
      <el-button @click.native="visible = false">取消</el-button>
      <!-- <el-button @click.native="printAll">打印值</el-button> -->
    </div>
  </el-dialog>
</template>
<script>
import Session from '@/utils/session'
import { querySetInfoPage, confirmInfo, queryItemCode, insertData, updateData } from '@/api/crossborder/collection/abroadCollection'
export default {
  name: 'payeeDialog',
  data() {
    return {
      title: '添加境外收款人',
      type: 'add', // add-新增 update-修改 lookup-查看
      visible: false,
      loading: false,
      addForm: {
        merNo: '',
        merName: '',
        payeeNo: '',
        accountName: '',
        accountNo: '',
        receiverAddr: '',
        bankName: '',
        bankAddr: '',
        bankSwiftBic: '',
        countryName: '',
        countryCode: '',
        settlementCurrencyName: '',
        settlementCurrencyCode: '',
        settlementCurrencyList: []
      },

      addFormRule: {
        accountName: [{ required: true, message: '请填写收款方名称', trigger: 'change' }],
        accountNo: [{ required: true, message: '请填写收款方账号', trigger: 'change' }],
        receiverAddr: [{ required: true, message: '请填写收款方地址', trigger: 'change' }],
        bankName: [{ required: true, message: '请填写开户行名称', trigger: 'change' }],
        bankAddr: [{ required: true, message: '请填写开户行地址', trigger: 'change' }],
        bankSwiftBic: [{ required: true, message: '请填写开户行swift BIC', trigger: 'change' }],
        countryName: [{ required: true, message: '请选择收款人常驻国家名称', trigger: 'change' }],
        settlementCurrencyName: [{ required: true, message: '请选择常用结算币种', trigger: 'change' }],
        settlementCurrencyList: [{ required: true, message: '请选择常用结算币种', trigger: 'change' }],
      },

      countryOptions: [],

      currencyOptions: [],
    }
  },

  mounted() {
    this.getCountryAreaCode()
    this.getCurrencyCode()
  },

  methods: {
    /**
     * 检查是否为银行号码
     *
     */
    check_banknum(event, propertyName) {
      let value = event.target.value.replace(/[^\w]/g, '')
      if (value.length > 25) {
        value = value.slice(0, 24)
      }
      this.addForm[propertyName] = value
    },

    getCountryAreaCode() {
      const param = {
        itemCode: 'country-area-code',
        size: 300,
      }
      queryItemCode(param)
        .then((res) => {
          this.countryOptions = res.data
        })
        .catch((error) => {
          //  this.$message.error(error)
          console.log(error)
        })
    },

    getCurrencyCode() {
      const param1 = {
        itemCode: 'currency',
        size: 300,
      }
      queryItemCode(param1)
        .then((res) => {
          this.currencyOptions = res.data
        })
        .catch((error) => {
          // this.$message.error(error)
          console.log(error)
        })
    },

    getCountryValue(event) {
      this.addForm.countryCode = event.paramKey
      this.addForm.countryName = event.paramValue
    },

    getCurrencyValue(event) {
      this.addForm.settlementCurrencyCode = event.paramKey
      this.addForm.settlementCurrencyName = event.paramValue
    },

    open(type, payeeNo) {
      this.type = type

      this.addForm.merNo = Session.getItem('merNo')
      this.addForm.merName = Session.getItem('merName')

      this.addForm.accountName = ''
      this.addForm.accountNo = ''
      this.addForm.bankName = ''
      this.addForm.bankAddr = ''
      this.addForm.bankSwiftBic = ''
      this.addForm.receiverAddr = ''
      this.addForm.countryCode = ''
      this.addForm.countryName = ''
      this.addForm.settlementCurrencyCode = ''
      this.addForm.settlementCurrencyName = ''
      this.addForm.settlementCurrencyList = []

      if (type === 'add') {
        this.title = '添加境外收款人'
      } else if (type === 'update') {
        this.title = '修改境外收款人'
      } else if (type === 'lookup') {
        this.title = '查看境外收款人'
      }

      this.visible = true
      if (type === 'update' || type === 'lookup') {
        if (!payeeNo) {
          this.$message.error('未获取到付款人编号')
          this.close()
          return
        }

        const param = {
          payeeNo,
          merNo: Session.getItem('merNo'),
        }
        this.loading = true
        confirmInfo(param)
          .then((res) => {
            this.loading = false
            this.addForm = res.data
            this.$nextTick(() => {
              this.$refs.addForm.clearValidate()
            })
          })
          .catch((error) => {
            console.log('获取跨境付款人信息错误', error)
            this.loading = false
            this.close()
          })
      }

      this.$nextTick(() => {
        this.$refs.addForm.clearValidate()
      })
    },

    close() {
      this.visible = false
    },

    submit() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          const param = Object.assign({}, this.addForm)
          if (this.type === 'add') {
            this.loading = true
            insertData(param)
              .then((res) => {
                this.loading = false
                this.$message.success('成功')
                this.$emit('query') // 发送查询事件，让父组件查询相应列表
                this.close()
              })
              .catch((error) => {
                this.loading = false
                console.log('添加境外付款人失败', error)
              })
          }

          if (this.type === 'update') {
            this.loading = true
            updateData(param)
              .then((res) => {
                this.loading = false
                this.$message.success('成功')
                this.close()
              })
              .catch((error) => {
                this.loading = false
                console.log('修复境外付款人失败', error)
              })
          }
        }
      })
    },

    printAll() {
      console.log('this.addForm', this.addForm)
    },
  },
}
</script>
<style scoped>
::v-deep .el-form-item__content {
  width: 270px;
}
::v-deep .el-select{
  width: 100%;
}
</style>